// extracted by mini-css-extract-plugin
export default {"review":"ReviewProducts_review__Og6DM","card":"ReviewProducts_card__cx8RJ"};